import { U as Url } from './url.min.js';

/**
 * **Dirs21**
 *
 * Official: http://www.dirs21.de
 *
 * Example: <a href="https://v4.ibe.dirs21.de/channels/scheelehofde/?culture=de-DE&arrival=2018-03-21#start" target="_blank">Scheelhoff</a>
 *
 * @exports bs_174
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  let refresPriceV2;
  let onPurchaseEvent = null;

  /**
     * In the BE use the <tt>d21</tt> var to access lang info.
     * Otherwise reject the Promise to use the fallback html's lang attr.
     *
     * @memberOf module:bs_174
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const langs = {
        español: 'es',
        العربية: 'ar',
        'Deutsch (CH)': 'de',
        'Deutsch (AT)': 'de',
        'Deutsch (DE)': 'de',
        'English (US)': 'en',
        'English (UK)': 'en',
        magyar: 'hu',
        polski: 'pl',
        dansk: 'da',
        italiano: 'it',
        Nederlands: 'nl',
        svenska: 'sv',
        français: 'fr',
        русский: 'ru',
        中文: 'zh',
      };

      let language;

      if (thn.data.accountUserId !== 1033485 && window.location.hostname.match(/starinnhotels.com|silberkoenig.de/)) {
        if (window.location.pathname.match(/^\/\w{2}\//)) {
          language = 'en';
        } else {
          language = 'de';
        }
      }

      if (thn.data.accountUserId === 1036148 && !((window.jQuery && window.jQuery('.d21-content:visible').length > 0) || document.getElementById('d21-modal-fullsize'))) {
        language = window.location.pathname.match(ctx.urlRe);
        language = language && language.length && language[1];
        if (language && ctx.langs.test(language)) {
          resolve(language);
          return;
        }

      }

      const lang = ((((document.querySelector('.d21-language-selected') || {}).childNodes || [])[4] || {}).textContent || '').trim();

      if (/sander-hotel.com/.test(window.location.hostname)) {
        language = document.querySelector('[itemprop=inLanguage]')?.content.slice(0, 2);
        if (language && ctx.langs.test(language)) {
          resolve(language);
          return;
        }
        language = langs[lang];
        resolve(language);
        return;
      }

      if (lang) {
        language = langs[lang];
      }

      if (ctx.langs.test(language)) {
        resolve(language);
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_174
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = thn.debounce(function (ctx) {
    if (thn.data.accountUserId === 1036148) {
      thn.languageCheck();
    }
    thn.pageCheck();
  }, 700);

  /**
     * Hijack <tt>d21.ui.fn.action</tt> to trigger {@link page_check}.
     *
     * When not iframed observe the direct addition/substraction of body's
     * child nodes. If a '.d21-content:visible' element exists, this is
     * a "Booking Iframe" page.
     *
     * @memberOf module:bs_174
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot(ctx) {

    const d21 = window.d21;

    if (d21 && d21.ui) {

      const _action = d21.ui.fn.action;
      d21.ui.fn.action = function action() {
        // call the original
        _action.call(this, arguments);
        thn.logger.debug('d21.ui.fn.action has been called: do a page_check in 2s ...');
        // do THN stuff
        setTimeout(thn.pageCheck, 2000);
      };
    }

    if (thn.isIframed()) {

      // Only when iframed (in the IBE) ...

      window.parent.postMessage({ action: 'thn_page_unload' }, '*');

      // observation of the #d21-justMe div needed to detect "Booking Confirmed" page
      // observation of the #d21-result div needed to detect "Rooms & Rates" page
      const els = document.querySelectorAll('#d21-justMe, #d21-result');

      if (els.length) {

        const pageCheckFunc = function () {
          thn.logger.debug('#d21-justMe or #d21-result changed: do a page_check in 2s ...');
          setTimeout(thn.pageCheck, 2000);
        };

        [...els].forEach((el) => {
          thn.observeDom(el, pageCheckFunc, {
            attributes: true,
            attributeFilter: ['class', 'style'],
          });

          thn.shutdown(function () {
            thn.stopObserveDom(el, pageCheckFunc);
          });
        });

      }

    } else {

      // Only when not iframed (not in the IBE) ...
      //
      // observe the body for child addition/removal

      const observerFunc = function (mutations) {
        let updateFunction;
        let d21Content;
        Array.from(mutations).forEach(function (mutation) {
          Array.from(mutation.addedNodes).forEach(function (node) {

            if (node.id) {
            // remove the previous observer
              if (thn.removeD21ContentObserver) {
                thn.removeD21ContentObserver();
                delete thn.removeD21ContentObserver;
              }
              // build a new observer
              updateFunction = thn.debounce(thn.pageCheck, 400);
              d21Content = node.childNodes[0]; // "div.d21-content"
              // this observation works paired with the pages mapping
              // if '.d21-content' is visible this is a "Booking Iframe"
              thn.observeDom(d21Content, updateFunction, {
                childList: false,
                subtree: false,
                characterData: false,
                attributes: true,
                attributesFilter: ['style', 'class'],
              });
              // do a page_check upfront (in case '.d21-content' is already visible)
              updateFunction();
              thn.removeD21ContentObserver = function thnRemoveD21ContentObserver() {
                thn.stopObserveDom(d21Content, updateFunction);
              };
            }
          });
        });
      };

      thn.observeDom(document.getElementsByTagName('body')[0], observerFunc, {
        childList: true,
        subtree: true,
        characterData: false,
      });

      thn.shutdown(function () {
        thn.stopObserveDom(document.getElementsByTagName('body')[0], observerFunc);
      });

      const bodyContainer = document.querySelector('#index_html, #id-1');

      let bodyObserver = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(bodyContainer, bodyObserver, {
        childList: false,
        subtree: false,
        attributes: true,
      });

      thn.shutdown(function () {
        bodyObserver.cancel();
        thn.stopObserveDom(bodyContainer, bodyObserver);
        bodyObserver = null;
      });
    }
  };

  /**
     * @memberOf module:bs_174
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {

    const url = new Url(ctx.baseUrl);
    const validUrlV2 = url.host.includes('reservation.one.dirs21') && url.path.includes('/result');

    // Rooms dispo function in order to get the parameters by the url in R&R only.
    function getRoomsDispo() {
      const inputString = thn.parseUrlParameter('sets');
      const data = JSON.parse(inputString);
      const occupancyList = data.map((item) => item.occupancy);
      return occupancyList;
    }

    if (url.host === 'v4.ibe.dirs21.de' && url.path.match(new RegExp('^/channels/[^/]+/?$'))) {

      // prepare URL for params substitution
      url.query.arrival = '[date_begin]';
      url.query.los = '[nights]';
      // export into ctx.new_url
      ctx.newUrl = url.decode(url.toString());

      // this BE uses datein/nights instead of dateout
      // calc the nights before any manipulation
      ctx.newData.nights = ctx.newData.dateBegin && ctx.newData.dateEnd
        ? thn.daysBetween(ctx.newData.dateBegin.replace(/-/g, '/'), ctx.newData.dateEnd.replace(/-/g, '/')) : 1;
      // then format of dates: yyyy/mm/dd -> yyyy-mm-dd
      ctx.newData.dateBegin = ctx.newData.dateBegin && ctx.newData.dateBegin.replace(/\//g, '-');
    } else if (validUrlV2) {
      // Creation of setsData for the new URL.
      let setsData;

      // Dates format: yyyy/mm/dd -> yyyy-mm-dd
      ctx.newData.dateBegin = ctx.newData.dateBegin.replace(/\//g, '-');
      ctx.newData.dateEnd = ctx.newData.dateEnd.replace(/\//g, '-');

      // Assignation of the range parameter
      const range = `${ctx.newData.dateBegin},${ctx.newData.dateEnd}`;
      url.query.range = range;

      // Check if we are in R&R, if not, we will use the roomsDispo from the ctx.data
      if (thn.data.pageName !== 'Rooms and Rates') {
        setsData = ctx.data.roomsDispo.map((room) => ({
          occupancy: {
            adultCount: room.adults,
            children: room.childrenAges || [],
          },
        }));

      // If we are in R&R, we will use the roomsDispo from the URL
      } else {
        // https://reservation.one.dirs21.de/hotel-amarisde/result?range=2024-11-01,2024-11-02&sets=[{%22uuid%22:%2222abaaa2-00d3-403a-ae37-5d6f24578304%22,%22occupancy%22:{%22adultCount%22:2,%22children%22:[]}}]&culture=de-DE&show_results=true&los=1
        const roomsDispo = getRoomsDispo();
        for (let i = 0; i < roomsDispo.length; i += 1) {
          setsData = roomsDispo.map((room) => ({
            occupancy: {
              adultCount: room.adultCount,
              children: room.children || [],
            },
          }));
        }
      }
      // Assignation of the sets parameter
      url.query.sets = JSON.stringify(setsData);

      // Assignation of the language parameter
      const language = ctx.data.language;
      url.query.culture = language;

      // We assign the show_results parameter to true, if we don't do that, the BE will not show the results.
      url.query.show_results = true;

      // Assignation of the los parameter
      const nights = thn.daysBetween(ctx.newData.dateBegin, ctx.newData.dateEnd);
      url.query.los = nights;

      // Export into ctx.newUrl
      ctx.newUrl = url.toString();
    } else {
      // This is not a valid BE URL
      ctx.newUrl = '';
    }

    return ctx;
  };

  /**
     * @memberOf module:bs_174
     * @see {@link Price#get_promocode}
     *
     * @param {object} ctx - The context object.
     */
  engine.getPromocode = function getPromocode(ctx) {
    const d21 = window.d21;

    if (d21 && d21.query && d21.query.rateName) {
      ctx.promocode = d21.query.rateName();
    }

    return ctx.promocode;
  };

  /**
     * Observe the "#d21-summary" element, and hijack the
     * <tt>d21.ui.fn.switchCurrency</tt> function.
     *
     * @memberOf module:bs_174
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const d21 = window.d21;
    const el = document.getElementById('d21-result');

    // do this just once
    if (!el && thn.dirs21Updater) {
      return;
    }

    // preventively remove the review widget
    if (thn.isIframed()) {
      this.transmit({ action: 'remove_review_widget' });
    }

    if ([1036102, 1044762].includes(thn.data.propertyId)) {
      // define the updater function
      thn.dirs21Updater = thn.debounce(function thnDirs21Updater() {

        if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName)) {
          ctx.widget.update();
        }
      }, 800);
      // observe the summary element
      thn.observeDom(el, thn.dirs21Updater, {
        attributes: false,
        childList: true,
        children: false,
        subtree: false,
      });

      // stop observation if we leave Rooms and Rates
      thn.pageUnload(function () {
        thn.stopObserveDom(el, thn.dirs21Updater);
        delete thn.dirs21Updater;
      });

      const container = document.querySelector('body');
      if (container) {
        const refreshPrice = thn.debounce(() => {
          const noAvailability = thn.isVisible(document.querySelector('.d21-toast-big'));
          if (noAvailability) {
            thn.widgets.price.update();
          }
        }, 800);

        thn.observeDom(container, refreshPrice, {
          childList: true,
          attributes: false,
          children: true,
          subtree: false,
        });

        thn.pageUnload(() => {
          refreshPrice.cancel();
          thn.stopObserveDom(container, refreshPrice);
        });
      }
    } else {
      // define the updater function
      thn.dirs21Updater = thn.debounce(function thnDirs21Updater() {

        if (['Rooms and Rates', 'Packages'].includes(thn.data.pageName)
    && ctx.widget.refresh() && !ctx.widget.isSet()) {
          ctx.widget.hide();
        }
        // Wait longer to enable the function, mixed results may show up if the user modifies the number of nights
        // while the previous search was not finished.
        // There aren't any visible loaders, and even the d21 integrated "is_loading" functions return false.
      }, 3000);
      // observe the summary element
      thn.observeDom(el, thn.dirs21Updater, {
        attributes: true,
        children: false,
        childList: false,
      });

      // stop observation if we leave Rooms and Rates
      thn.pageUnload(function () {
        thn.stopObserveDom(el, thn.dirs21Updater);
        delete thn.dirs21Updater;
      });
    }

    // hijack the switchCurrency function
    const _switchCurrency = window.d21 && d21?.ui?.fn?.switchCurrency;
    if (_switchCurrency) {

      d21.ui.fn._switchCurrency = function switchCurrency() {
        // call the original
        _switchCurrency.call(this, arguments);
        // do THN stuff
        thn.dirs21Updater();
      };

      thn.pageUnload(function () {
        // restore the original function
        d21.ui.fn.switchCurrency = _switchCurrency;
      });
    }

    // Price observer v2
    const containerRooms = document.querySelector('#scrollToArea');

    if (containerRooms && !refresPriceV2) {
      refresPriceV2 = thn.debounce(() => {
        ctx.widget.refresh();
      }, 500);

      thn.observeDom(containerRooms, refresPriceV2, {
        childList: true,
        attributes: false,
        subtree: false,
      });

      thn.pageUnload(() => {
        refresPriceV2.cancel();
        thn.stopObserveDom(containerRooms, refresPriceV2);
        refresPriceV2 = null;
      });
    }
  };

  /**
     * Uses global object <tt>window.d21</tt>.
     *
     * Implements **noRooms**.
     *
     * @memberOf module:bs_174
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData_v1 = function priceParseData_v1(ctx) {

    const widgetData = {};
    const d21 = window.d21;
    let room1Info;
    let nights;

    if (!d21) {
      return widgetData;
    }

    // Homepages could have on each room page one button that redirects to Dirs21 applying a room filter that only show the selected room
    // This may lead to disparities.
    // We need to check if on the URL of the BE we have a parameter called 'room_id' which is used to filter out rooms
    const roomFilterApplied = thn.parseUrlParameter('room_id') || thn.parseUrlParameter('package_id');

    // Some clients prefers to exclude the visits entirely if a room filter is applied
    // If the property is not in the following exception, we will just flag the search as special rate
    const excludeRoomFilters = [1027018, 1028810].includes(thn.data.propertyId) && roomFilterApplied;

    if (excludeRoomFilters) {
      this.logger.debug('Rooms filter applied, ignoring current search');
      return widgetData;
    }

    const dispo = d21.result && d21.result.properties && d21.result.properties();

    const calendar = d21.query?.calendar;

    if (calendar) {

      const dateBegin = typeof calendar.arrival === 'function' && ((calendar.arrival() || {}).date || {});
      const dateEnd = typeof calendar.departure === 'function' && ((calendar.departure() || {}).date || {});

      if (typeof dateBegin.customFormat === 'function'
        && typeof dateEnd.customFormat === 'function'
      ) {
        widgetData.dateBegin = dateBegin.customFormat('YYYY/MM/DD', true);
        widgetData.dateEnd = dateEnd.customFormat('YYYY/MM/DD', true);
      }
    }

    if (widgetData.dateBegin && widgetData.dateEnd) {
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    widgetData.rooms = 1;

    const roomHandler = d21.roomHandler || {};
    let childrenAges;

    if (roomHandler && typeof roomHandler.items === 'function') {
      const guests = (roomHandler.items() || {})[0] || {};

      widgetData.adults = (typeof guests.numberOfAdults === 'function' && guests.numberOfAdults()) || 2;
      widgetData.children = (typeof guests.numberOfChildren === 'function' && guests.numberOfChildren()) || 0;
      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

      childrenAges = typeof guests.children === 'function' && guests.children();
    }

    if (!thn.empty(childrenAges)) {
      // build the detailed room information
      room1Info = {
        adults: widgetData.adults,
        children: widgetData.children,
        childrenAges: childrenAges.map(function (c) { return c.age(); }),
      };
      // add the room info to the "roomsDispo"
      widgetData.roomsDispo = [room1Info];
    }

    // defualt Hotel currency
    // widgetData.currency = d21.ui.summary.property().Culture.Currency;

    const financial = (d21.config && d21.config.financial) || {};
    let factor;

    if (!thn.empty(financial)) {

      if (typeof financial.currency === 'function') {
        // user currency
        widgetData.currency = financial.currency();
      }
      // each price must be multiplied by this
      factor = financial.factor || 1;
    }

    if (thn.empty(dispo)) {

      widgetData.noRooms = true;

    } else {

      const prices = [];
      // Room details
      const roomDetails = {};
      d21?.result?.properties()[0]?.Sets[0]?.Masonry?.Columns?.forEach(function (room) {
        if (thn.empty(room.Items)) {
          return;
        }
        room = room.Items[0];
        const roomData = {
          id: room._id,
          name: d21.result.model().Info.ex.rooms[room._id].Name,
          adults: d21.result.model().Info.ex.rooms[room._id].OccupancyMax,
          prices: room.Rates.map(function (rate) {
            // Important: convert the price to the user currency
            let price;

            if (nights) {
              price = (rate.Price() * factor) / nights;
              prices.push(price);
            }

            return {
              id: rate._id,
              name: '',
              rate: '',
              price: price,
              breakfast: (rate.Board || '').match(/breakfast/i) ? 1 : 0,
              refundable: rate.Facts.some(function (f) {
                return (f.Text || '').match(/cancellable (for free|without)/i);
              }) ? 1 : 0,
            };
          }),
        };
        if (roomData.name.match(/\bsuite\b/i)) {
          roomData.type = 'suite';
        } else {
          roomData.type = 'standard';
        }
        if (!roomDetails[roomData.id]) {
          roomDetails[roomData.id] = roomData;
        }
      });

      if (Object.keys(roomDetails).length) {
        widgetData.roomDetails = [];
        Object.keys(roomDetails).forEach(function (idx) {
          widgetData.roomDetails.push(roomDetails[idx]);
        });
      }

      widgetData.price = Math.min(...prices);
    }

    if (widgetData.price && widgetData.currency) {
      widgetData.set = true;

      if (roomFilterApplied) {
        widgetData.priceSpecial = 1;
      }
    }

    return widgetData;
  };

  engine.priceParseData_v2 = function priceParseData_v2(ctx) {
    const widgetData = {};
    // Dates
    const datesArray = thn.parseUrlParameter('range')?.split(',');
    const dateBegin = datesArray?.[0]?.replace(/-/g, '/');
    const dateEnd = datesArray?.[1]?.replace(/-/g, '/');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }

    // adults and children
    const currentRoom = thn.parseNumber(document.querySelector('div[id*=headlessui-radiogroup-option][data-headlessui-state="checked"] span.font-bold')?.textContent) ?? 1;
    const paramDataArray = JSON.parse(thn.parseUrlParameter('sets'));
    const roomInfo = {
      adults: thn.objectGet(paramDataArray[currentRoom - 1], 'adultCount') ?? 2,
      children: thn.objectGet(paramDataArray[currentRoom - 1], 'children')?.length ?? 0,
      childrenAges: thn.objectGet(paramDataArray[currentRoom - 1], 'children'),
    };

    widgetData.roomsDispo = [roomInfo];

    // Price and currency
    const priceSelector = 'swiper-container div span.text-xl, main>div:nth-child(2)>div:nth-child(1)>div:nth-child(2) span:not(.text-negative).text-primary, .card>div>section>section>div> span:nth-child(1), swiper-container div span.text-xl, main>div:nth-child(2)>div:nth-child(1)>div:nth-child(2) span:not(.text-negative).text-primary, .card>div>section>section>div> p:nth-child(1)';
    const pricesArray = [...document.querySelectorAll(priceSelector)]
      .map((price) => thn.parseNumber(price.textContent));
    const currency = thn.parseCurrency(document.querySelector(priceSelector)?.textContent);
    const noAvailability = !!document.querySelector('#result div:first-child .fa-circle-info');
    if (!thn.empty(pricesArray) && currency) {
      widgetData.price = Math.min(...pricesArray);
      widgetData.currency = currency;
      widgetData.set = true;
    } else if (noAvailability) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
   * @memberOf module:bs_175
   * @this thn.widgets.booking
   * @see {@link Booking#observeDom}
   *
   * @param {object} ctx - The context object.
   */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    if (onPurchaseEvent) {
      // Already listening, skip ...
      return;
    }

    if (this.isSet()) {
      // Data was already set, skip ...
      return;
    }

    onPurchaseEvent = ({ message }) => {
      if ((message?.[1] === 'purchase' || message?.[2]?.event_category === 'Confirmation') && this.setData().isSet()) {
        this.save();
        thn.bus.detach('dataLayer:push', onPurchaseEvent);
      }
    };

    thn.bus.on('dataLayer:push', onPurchaseEvent, true);
    thn.pageUnload(() => {
      thn.bus.detach('dataLayer:push', onPurchaseEvent);
    });
  };

  /**
     * Implements **bookingId**.
     *
     * @memberOf module:bs_174
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const dataLayer = window.dataLayer;
    const widgetData = {};
    const d21 = window.d21;
    const bookingData = dataLayer.find((item) => item?.[1] === 'purchase')?.[2];
    const bookingId = thn.objectGet(bookingData, 'transaction_id');

    if (d21 && d21.res && d21.res.model) {

      widgetData.price = d21.res.model.Total.Sum;
      widgetData.currency = d21.res.model.Total.Currency;
      widgetData.dateBegin = d21.res.model.Arrival.Date.replace(/-/g, '/');
      widgetData.dateEnd = d21.res.model.Departure.Date.replace(/-/g, '/');
      widgetData.bookingId = d21.res.model._id;
    } else if (bookingId) { // Booking confirmation page version 2
      const datesArray = thn.parseUrlParameter('range')?.split(',');
      widgetData.dateBegin = datesArray?.[0]?.replace(/-/g, '/');
      widgetData.dateEnd = datesArray?.[1]?.replace(/-/g, '/');
      widgetData.bookingId = bookingId;
      widgetData.price = thn.objectGet(bookingData, 'value');
      widgetData.currency = thn.objectGet(bookingData, 'currency');
    }
    const queryResults = document.evaluate('//span[contains(text(),"%")]', document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
    if (queryResults.snapshotLength === 1) {
      const promocodeElement = queryResults.snapshotItem(0)?.parentElement?.parentElement?.querySelector('span')?.textContent;
      const promocode = promocodeElement?.match(/\(([^)]+)\)/)?.[1];
      if (promocodeElement) {
        widgetData.promocode = promocode;
      }
    }

    return widgetData;
  };

  return engine;

}

export { factory };
